/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import { Component, Input } from '@angular/core';
import { AppState } from '../../../app.service';
import { ViewMode } from '../../../model/view_mode';

@Component({
    selector: 'manage-view-mode',
    template: require('./ui-manage-view-mode.html'),
    styles: [require('./ui-manage-view-mode.less')],
})

export class ManageViewMode {
    @Input() viewModes: ViewMode[];
    @Input() switchViewMode: Function;
    @Input() title;

    constructor(public appState: AppState) {}
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/ui-manage-view-mode/ui-manage-view-mode.ts